"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createHasPermission = exports.Permission = void 0;
exports.Permission = {
    c: 'c',
    r: 'r',
    u: 'u',
    d: 'd',
    e: 'e',
    s: 's',
};
/**
 * Helper function that takes User Permissions object and returns a
 * utility function that will check permissions for certain features.
 * @param permissionMap User Permission object
 * @returns
 */
const createHasPermission = (permissionMap) => (dataClass, requiredAccess) => {
    var _a;
    if (permissionMap === null || permissionMap === void 0 ? void 0 : permissionMap[dataClass]) {
        if (typeof requiredAccess === 'string') {
            return (_a = permissionMap[dataClass]) === null || _a === void 0 ? void 0 : _a.includes(requiredAccess);
        }
        else {
            return requiredAccess.every((permission) => { var _a; return (_a = permissionMap[dataClass]) === null || _a === void 0 ? void 0 : _a.includes(permission); });
        }
    }
    return false;
};
exports.createHasPermission = createHasPermission;
//# sourceMappingURL=createHasPermission.js.map